import { combineRules } from 'fela';
import type { TRuleWithTheme } from '@ackee/fela';

import { BackgroundMode } from 'modules/homepage';

export const extendContainer: TRuleWithTheme = () => ({
    margin: 'auto',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    position: 'relative',
    padding: '7rem 0px',
    tabletLarge: {
        paddingLeft: '0',
        paddingRight: '0',
    },
});

const dynamicTextColor: TRuleWithTheme<{ backgroundMode?: BackgroundMode }> = ({ theme, backgroundMode }) => ({
    transition: theme.transition,
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,
});

export const extendOfficeContainer: TRuleWithTheme = combineRules(dynamicTextColor, () => ({
    flexDirection: 'column',
    paddingRight: '40px',
    tablet: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}));

export const extendTitle: TRuleWithTheme = combineRules(dynamicTextColor, () => ({
    maxWidth: '400px',
    margin: '5.25rem 0',
}));

export const extendTitleSection: TRuleWithTheme = combineRules(dynamicTextColor, () => ({
    marginBottom: 'unset',
}));
